module.exports = __webpack_public_path__ + "static/media/kitty8.55aecc41.jpg";